import { custom, deserialize, serializable } from 'serializr';
import { Application } from './application.model';
import { Base } from './base.model';
import { PageObject } from './page-object.model';
import { ApplicationType } from '@testsigma/organism';

export class Project extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public description: string;
  @serializable(
    custom(
      (v) => {
        if (v) return JSON.stringify(v);
      },
      (v) => {
        if (v && typeof v == 'string') return JSON.parse(v);
        else if (v) return v;
      },
    ),
  )
  public customFields: object;
  @serializable
  public type: number;
  @serializable
  public hasMultipleApps: boolean;
  @serializable
  public hasMultipleVersions: boolean;
  @serializable
  public isDemo: boolean;
  @serializable
  public projectType: ApplicationType;
  @serializable
  public createdById: number;
  @serializable
  public updatedById: number;
  @serializable
  public createdAtEpoch: Date;
  @serializable
  public updatedAtEpoch: Date;
  @serializable
  public roleId: number;
  @serializable
  public userProjectMappingId: number;

  @serializable(
    custom(
      (v) => {
        if (v) {
          const applications = [];
          v.forEach((app) => {
            applications.push(app.serialize());
          });
          return applications;
        }
      },
      (v) => {
        if (v) {
          const applications: Application[] = [];
          v.forEach((app) => {
            applications.push(new Application().deserialize(app));
          });
          return applications;
        }
      },
    ),
  )
  public applications: Application[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Project, input));
  }
}
